import React from 'react'
import { func, bool, string } from 'prop-types'
import {
  REVOKE_MFA_TITLE,
  REVOKE_MFA_CONFIRM,
  REVOKE_MFA_FORM_LABEL,
  REVOKE_MFA_FORM_PLACEHOLDER,
  REVOKE_MFA_GENERIC_ERROR,
  REVOKE_MFA_LAST_OPTION_SUBTITLE
} from '../../constants/ui.labels'
import { SETTINGS_PAGE } from '../../constants/links'
import { RECOVERY_OTP, Properties } from '../../constants/mfa'
import { ContentHeader, Error, DisableMFAForm } from '../../components'
import mapError from '../../utils/mapError/mfa'
import redirectTo from '../../utils/redirect/redirectTo'

export default class DisableMFA extends React.PureComponent {
  static propTypes = {
    onRevokeAllMFAMechanisms: func.isRequired,
    onRevokeMFAMechanism: func.isRequired,
    onExecuteRecaptcha: func.isRequired,
    isLastMFAMechanism: bool.isRequired,
    mfaToRevoke: string.isRequired,
    isMFARevokeInProgress: bool,
    isSuccessfullyRevoked: bool,
    revokeMFAErrorCode: string,
    siteKey: string.isRequired
  }

  static defaultProps = {
    revokeMFAErrorCode: null
  }

  state = {
    password: '',
    handledRevokeMfaConfirmSuccess: false
  }

  onFormChange = password => this.setState({ password })

  handleRevokeMfaConfirm = recaptchaResponse => {
    const {
      mfaToRevoke,
      isLastMFAMechanism,
      onRevokeAllMFAMechanisms,
      onRevokeMFAMechanism
    } = this.props

    if (isLastMFAMechanism || mfaToRevoke === RECOVERY_OTP) {
      onRevokeAllMFAMechanisms({
        password: this.state.password,
        recaptchaResponse: recaptchaResponse
      })
    } else {
      onRevokeMFAMechanism({
        mfaMechanism: mfaToRevoke,
        password: this.state.password,
        recaptchaResponse: recaptchaResponse
      })
    }
    this.setState({ handledRevokeMfaConfirmSuccess: true })
  }

  render() {
    const {
      isLastMFAMechanism,
      mfaToRevoke,
      isMFARevokeInProgress,
      revokeMFAErrorCode,
      isSuccessfullyRevoked,
      siteKey,
      onExecuteRecaptcha
    } = this.props

    const isFormValid = this.state.password !== ''
    const errorMessage =
      revokeMFAErrorCode &&
      mapError(revokeMFAErrorCode, REVOKE_MFA_GENERIC_ERROR)
    const mfaName = Properties[mfaToRevoke].name
    const title = REVOKE_MFA_TITLE(mfaName)
    const subtitle =
      isLastMFAMechanism && mfaToRevoke !== RECOVERY_OTP
        ? REVOKE_MFA_LAST_OPTION_SUBTITLE(mfaName)
        : ''

    return !isSuccessfullyRevoked ? (
      <React.Fragment>
        <ContentHeader title={title} message={subtitle} />
        <Error message={errorMessage} />
        {
          <DisableMFAForm
            onFormChange={this.onFormChange}
            onConfirm={this.handleRevokeMfaConfirm}
            onExecuteRecaptcha={onExecuteRecaptcha}
            confirmText={REVOKE_MFA_CONFIRM}
            formLabel={REVOKE_MFA_FORM_LABEL}
            formPlaceholder={REVOKE_MFA_FORM_PLACEHOLDER}
            isMFARevokeInProgress={isMFARevokeInProgress}
            isFormValid={isFormValid}
            siteKey={siteKey}
          />
        }
      </React.Fragment>
    ) : (
      redirectTo(SETTINGS_PAGE)
    )
  }
}
